import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncSiteHeader = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "header" */
        './SiteHeader'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
